import * as yup from "yup";

export const validationSchema = yup.object ({
    userId: yup.number ().required ("Required"),
    roleId: yup.number ().required ("Required"),
    keyLabel: yup.string ().required ("Required"),
    expiryDate: yup.date (),
    status: yup.boolean ()
});

export const initialValues = {
    userId: 0,
    roleId: 0,
    keyLabel: "",
    expiryDate: "",
    status: true
};